import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import ReactPlayer from "react-player";
import '../../css/styles.css';
import './ForParents/forParents.css';

class VideoViewerModal extends Component {
            constructor(props) {
              super(props);
              this.state={
                        }
    }
      
    topicSelected(topicName){
         switch (topicName){
            case "gameTrailer1":
                this.videoURL =  "https://www.youtube.com/watch?v=ZkCmHVqOV8s";
                break;
            case "gameTrailer2":
                // trailer for teachers
                this.videoURL = "https://www.youtube.com/watch?v=TyCgTu6VJU0";
                break;
            case "theBasics":
                this.videoURL = "https://www.youtube.com/watch?v=D8Cv98b561M"
                break;
            case "foundations":
                this.videoURL = "https://www.youtube.com/watch?v=GpgOcWTJozM";
                break;
            case "jobChoice":
                this.videoURL = "https://www.youtube.com/watch?v=hqnbWmHbn2A"
                break;
            case "homeChoice":
                this.videoURL = "https://www.youtube.com/watch?v=9Dq68UJxDNQ"
                break;
            case "carChoice":
                this.videoURL = "https://www.youtube.com/watch?v=_3h4UKatO44";
                break;
            case "needsVsWants":
                this.videoURL = "https://youtu.be/iiJ1-uLTvlc";
                break;
            case "introduction":
                this.videoURL = "https://www.youtube.com/watch?v=EmiLUfWpaZg";
                break;
            case "investments":
                this.videoURL = "https://www.youtube.com/watch?v=rehpYK1A7vQ";
                break;
            case "insurance":
                this.videoURL = "https://www.youtube.com/watch?v=fJmnUdMV544";
                break;
            case "wrapUp": 
                this.videoURL = "https://www.youtube.com/watch?v=-IcJ10O3N3U";
                break;
            default:
                break;
        }
    }

            
    render() {
        this.topicSelected(this.props.topicName);
    return <>
        <Modal show={this.props.show} className=""
            onHide={() => this.props.onClose()} size="lg" animation={false}
            >
       
        <Modal.Body>
            <div className="container bg-dark">
             <ReactPlayer
                    className="mx-auto d-block"

                    url={this.videoURL}
                    controls
                    playing

                    onEnded={() => this.props.onClose()}
                    onContextMenu={e => e.preventDefault()}

                    config={{
                        youtube: {
                        playerVars: {
                            origin: window.location.origin
                        }
                        },
                        file: {
                        attributes: {
                            controlsList: 'nodownload'
                        }
                        }
                    }}
            />
            </div>

        </Modal.Body>
        </Modal>
  
        </>
    }
}
export default VideoViewerModal;